// extracted by mini-css-extract-plugin
export default {"root":"VideoAdsEventbriteLogo-module__root___UD8AA","logo":"VideoAdsEventbriteLogo-module__logo___1zIeF"};